export enum DiscoverRoutes {
  root = 'discover',
  capture = 'capture',
  connect = 'connect',
  convert = 'convert',
  care = 'care',
}
